interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, currentPage - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2 mt-8" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(currentPage - 1)}
        disabled={currentPage <= 1}
        className="px-3 py-2 rounded-md text-sm border border-background-300 text-foreground-800 hover:bg-background-200 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className="w-9 h-9 rounded-md text-sm border border-background-300 text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer"
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-9 h-9 rounded-md text-sm border transition-colors cursor-pointer ${
            page === currentPage
              ? 'bg-primary-500 text-background-50 border-primary-500 font-semibold'
              : 'border-background-300 text-foreground-800 hover:bg-background-200'
          }`}
        >
          {page}
        </button>
      ))}
      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button
            type="button"
            onClick={() => onChange(totalPages)}
            className="w-9 h-9 rounded-md text-sm border border-background-300 text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer"
          >
            {totalPages}
          </button>
        </>
      )}
      <button
        type="button"
        onClick={() => onChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        className="px-3 py-2 rounded-md text-sm border border-background-300 text-foreground-800 hover:bg-background-200 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}